import React from 'react';

const FeatureSection = () => {
  const features = [
    {
      icon: (
        <svg className="w-12 h-12 text-primary-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      ),
      title: "Kiến thức chuyên sâu và cập nhật",
      description: "Đảm bảo học sinh luôn tiếp cận với những thông tin chính xác và tiên tiến nhất"
    },
    {
      icon: (
        <svg className="w-12 h-12 text-primary-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ),
      title: "Phương pháp sư phạm sáng tạo",
      description: "Sử dụng đa dạng các phương pháp giảng dạy, đến ứng dụng công nghệ, giúp học sinh phát triển toàn diện"
    },
    {
      icon: (
        <svg className="w-12 h-12 text-primary-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9V7h9v14z" />
        </svg>
      ),
      title: "Sự tận tâm và thấu hiểu",
      description: "Luôn lắng nghe, hỗ trợ và đồng hành cùng từng học sinh , giúp các em vượt qua khó khăn và phát huy tối đa tiềm năng bản thân"
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Chúng Tôi Luôn<span className="text-primary-600"> Tự Hào Về</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Kiến Thức - Phương Pháp - Đổi mới
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-primary-50 rounded-full">
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
